import mela from 'mela'
const animations = mela()
export default animations
